module.exports = __webpack_public_path__ + "static/media/4.Table vice.c669ce8c.jpg";